import { EventResolver } from "./event.resolver";

export const CORE_RESOLVERS= [EventResolver];
